import React, { ReactNode } from 'react';

import './tooltip.scss';

const Tooltip: React.FC<{ message: string; children: ReactNode; }> = ({ message, children }) => (
    <span className="tooltip-wrapper">
        <span className="tooltip">
            {message}
        </span>
        {children}
    </span>
);

export default Tooltip;
